<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li><a href="#">二办记账</a></li>
            </ul>
        </div>
        <div class="formbody">
            <div class="formtitle"><span>二办记账</span></div>
            <ul class="forminfo">
                <li>
                    <label>营业执照<b>*</b></label>

                    <el-upload :action=uploadUrl list-type="picture-card" :headers="uploadHeaders"
                        :limit="1"  :class="{ hidden: fileList.length >= 1 }" :on-exceed="handleExceed"
                        :on-success="handleSuccess" :on-preview="handlePictureCardPreview" :on-remove="handleRemove">
                        <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                        <img width="100%" :src="dialogImageUrl" alt="">
                    </el-dialog>
                </li>

                <li><label>税务账号<b>*</b></label><input name="" type="text" v-model="taxaccount" class="dfinput"
                        value="" /></li>

                <li><label>税务密码<b>*</b></label><input name="" type="text" v-model="taxpwd" class="dfinput" value="" />
                </li>

                <li><label>验证码<b></b></label><input name="" type="text" v-model="smscode" class="dfinput" value="" />
                </li>

                <li><label>&nbsp;</label><input class="sure" type="button" @click="send()" value="确定">&nbsp;
                    <!-- <input class="cancel" type="button" value="取消"> -->
                </li>
            </ul>
        </div>


    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
export default {
    components: {
        'v-cookie': cookie,
    },
    data() {
        return {
            taxaccount:'',
            taxpwd:'',
            smscode:'',
            uploadHeaders: {},
            uploadUrl: this.GLOBAL.serverSrc + '/taxbooks/uploadcompanycode.json',
            msg: '',
            dialogImageUrl: '',
            dialogVisible: false,
            fileList: [],
            companycodepath:'',
        }
    },
    mounted() {
        this.uploadHeaders.token = this.GLOBAL.token;
        // this.getEnterpriseInfo();
    },
    methods: {
        handleChange(file, fileList) {

        },
        uploadSuccess(response) {

            if (response.code === '0000000') {
                if (response.type == 'personid') {
                    this.personID = response.filePath;
                }
                else if (response.type == 'companycode') {
                    this.companycodepath = response.filePath;
                }
            }
            else if ("0000006" == response.code) {
                // this.buttonDisabled = false
                this.$alert(response.message, '格式错误，文件必须是txt格式！', {
                    confirmButtonText: '确定'
                })
                this.$refs.upload.clearFiles()
            }
            else {
                alert(response.msg);
            }
        },
        getEnterpriseInfo() {
            let that = this
            let data = {}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/enterprise/enterpriseinfo.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token': this.GLOBAL.token
                }
            }).then(function (res) {
                if ('0000000' == res.data.code) {
                    //console.log(res.data.enterprise);
                    that.companyname = res.data.enterprise.companyname
                    that.companyaddress = res.data.enterprise.companyaddress
                    that.contact = res.data.enterprise.contact
                    that.phonenum = res.data.enterprise.phonenum
                    that.mobile = res.data.enterprise.mobile
                    that.email = res.data.enterprise.email
                    that.subaccountnum = res.data.enterprise.subaccountnum
                    that.subnum = res.data.enterprise.subnum
                    that.status = res.data.enterprise.status
                    that.personID = res.data.enterprise.personID == undefined ? '' : res.data.enterprise.personID;
                    that.companycode = res.data.enterprise.companycode == undefined ? '' : res.data.enterprise.companycode;
                    that.msg = res.data.enterprise.msg
                }
                else {
                    alert(res.data.msg)
                }
            })
        },
        delfile(filetype) {
            if (!confirm("确定需要删除文件吗？")) {
                return;
            }
            let that = this
            let data = { 'fileType': filetype }
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/enterprise/delenterprisefile.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token': this.GLOBAL.token
                }
            }).then(function (res) {
                if ('0000000' == res.data.code) {
                    that.getEnterpriseInfo();
                }
                else {
                    alert(res.data.msg)
                }
            })
        },
        send() {
            if (this.companycodepath.trim().length < 1) {
                alert("请先上传营业执照！");
                return;
            }
            if (this.taxaccount.trim().length < 1) {
                alert("请先填写税务账号！");
                return;
            }
            if (this.taxpwd.trim().length < 1) {
                alert("请先填写税务密码！");
                return;
            }
            let data = { 'companycodepath': this.companycodepath, 'taxaccount': this.taxaccount, 'taxpwd': this.taxpwd, 'smscode': this.smscode }
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + '/taxbooks/send.json',
                data: data,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token': this.GLOBAL.token
                }
            }).then(function (res) {
                if ('0000000' == res.data.code) {
                    alert("提交成功！")
                }
                else {
                    alert(res.data.msg)
                }
            })
        },
        handleRemove(file, fileList) {
            console.log(file, fileList);
        },
        handlePictureCardPreview(file) {
            console.log(file);
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        handleSuccess(response, file, fileList) {
            console.log('上传成功');
            console.log('response',response);
            console.log('file',file);
            console.log('fileList',fileList);
            this.companycodepath = response.filePath;
            // 你可以在这里处理上传成功后的逻辑，例如更新fileList等
            // this.fileList = fileList; // 更新文件列表显示
        },
    }
}
</script>
<style scoped>
/* 核心5：当.hidden类生效时，隐藏上传按钮 */
.hidden /deep/ .el-upload--picture-card {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/taxbooks/taxbookssend.vue